// frontend/admin-portal/src/services/userService.js
import api from './axiosConfig';

export const userService = {
    list: async (params = {}) => {
        const { data } = await api.get('/users', { params });
        return data.data;
    },
    stats: async () => {
        const { data } = await api.get('/users/stats');
        return data.data;
    },
    get: async (id) => {
        const { data } = await api.get(`/users/${id}`);
        return data.data.user;
    },
    create: async (payload) => {
        const { data } = await api.post('/users', payload);
        return data.data;   // { user, temporaryPassword? }
    },
    update: async (id, payload) => {
        const { data } = await api.put(`/users/${id}`, payload);
        return data.data.user;
    },
    remove: async (id) => {
        const { data } = await api.delete(`/users/${id}`);
        return data;
    },
    toggleActive: async (id) => {
        const { data } = await api.patch(`/users/${id}/toggle`);
        return data.data.user;
    },
    unlock: async (id) => {
        const { data } = await api.patch(`/users/${id}/unlock`);
        return data.data.user;
    },
    resetPassword: async (id, { newPassword, sendTempPassword } = {}) => {
        const { data } = await api.post(`/users/${id}/reset-password`, { newPassword, sendTempPassword });
        return data.data;   // { temporaryPassword? }
    },
    forceLogout: async (id) => {
        const { data } = await api.post(`/users/${id}/force-logout`);
        return data;
    },
};